import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import * as _ from 'lodash-es';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import * as $ from 'jquery';
import { StateHelperService } from './core.ui.state.service';
import * as webNotification from 'simple-web-notification';
import { HtmlToPlainTextPipe } from '../pipes/text/html-text.pipe';

    /** Utiliy methods for color handling **/
    function stringToClassColor(str, index = 0) {
        function getHashCode(str) {
            var hash = 0;
            if (str.length == 0) return hash;
            for (var i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
                hash = hash & hash; // Convert to 32bit integer
            }
            return Math.abs(hash);
        };

        function roundedVal(i) {
            return Math.round((Math.ceil(i / 30)) * 30);
        };

        function intToRGB(i) {
            var hex =
                roundedVal((i >> 16) & 0xFF).toString(12) +
                roundedVal((i >> 8) & 0xFF).toString(8) +
                roundedVal(i & 0xFF).toString(16);
            // Sometimes the string returned will be too short so we
            // add zeros to pad it out, which later get removed if
            // the length is greater than six.
            hex += '000000';
            return hex.substring(0, 6);
        };

        const ret = '#' + intToRGB(getHashCode(str));
        // console.log("stringToClassColor", str, ret);
        return ret;
    }

    function setTagColors(tags) {
        return _.map(
            tags,
            function(tag) {
                if (! tag.bgcolor) {
                    tag.bgcolor = stringToClassColor(tag.text);
                }
                return tag;
            }
        );
    }
@Injectable()
export class UiService {
    private _isOnFocus: boolean;
    private document;
    private htmlToPlainTextPipe = new HtmlToPlainTextPipe();

    constructor(private http: HttpClient, private stateHelperService: StateHelperService, private window: Window,  @Inject(DOCUMENT) document: Document
    ) {
        this.http = http;
        this.window = window;
        this.document = document;
        this.stateHelperService = stateHelperService;

        this._isOnFocus = true;

        this.window.addEventListener('focus', event => {
            this._isOnFocus = true;
        });
        this.window.addEventListener('blur', event => {
            this._isOnFocus = false;
        });
    }

    get isOnFocus(): boolean{
        return this._isOnFocus;
    }

    //Returns 'message' sub-namespace
    get message() {
        var _self = this;

        function showSuccessMsgProxy(_self) {
            return (...args) => { _self.showSuccessMsg(...args) };
        }

        function showInfoMsgProxy(_self) {
            return (...args) => { _self.showInfoMsg(...args) };
        }

        function showWarningMsgProxy(_self) {
            return (...args) => { _self.showWarningMsg(...args) };
        }

        function showErrorMsgProxy(_self) {
            return (...args) => { _self.showErrorMsg(...args) };
        }

        function showJobMessageProxy(_self) {
            return (...args) => { _self.showJobMessage(...args) };
        }

        //Returns an object with closures for each method,
        //to preserve the lexical scope of the instance
        return {
            showSuccess: showSuccessMsgProxy(_self),
            showInfo: showInfoMsgProxy(_self),
            showWarning: showWarningMsgProxy(_self),
            showError: showErrorMsgProxy(_self),
            showJobMessage: showJobMessageProxy(_self)
        };
    }

    //Returns 'form' sub-namespace
    get form() {
        var _self = this;

        function showErrorMsgProxy(_self) {
            return (...args) => { _self.showErrorMsg(...args) };
        }

        function getParentProxy(_self) {
            return (...args) => { _self.getParent(...args) };
        }

        function clearProxy(_self) {
            return (...args) => { _self.clear(...args) };
        }

        function removeCheckingProxy(_self) {
            return (...args) => { _self.removeChecking(...args) };
        }

        function showProxy(_self) {
            return (...args) => { _self.show(...args) };
        }

        function showCheckingProxy(_self) {
            return (...args) => { _self.showChecking(...args) };
        }

        //Returns an object with closures for each method,
        //to preserve the lexical scope of the instance

        return {
            showFormError: showErrorMsgProxy(_self),
            fields: {
                message: {
                    getParent: getParentProxy(_self),
                    clear: clearProxy(_self),
                    removeChecking: removeCheckingProxy(_self),
                    show: showProxy(_self),
                    showChecking: showCheckingProxy(_self)
                }
            }
        }
    }

    //Returns 'color' sub-namespace
    get color() {
        //Returns an object with closures for each method,
        //to preserve the lexical scope of the instance
        return {
            stringToClassColor: stringToClassColor,
            setTagColors: setTagColors,
        }
    }

    //Returns 'state' sub-namespace
    get state() {
        var _self = this;

        function getStateForSectionRefIdProxy(_self) {
            return (...args) => { _self.stateHelperService.getStateForSectionRefId(...args) };
        }

        function getUrlForSectionRefIdProxy(_self) {
            return (...args) => { _self.stateHelperService.getUrlForSectionRefId(...args) };
        }

        function serializeProxy(_self) {
            return (...args) => { _self.stateHelperService.serialize(...args) };
        }

        function goToItemProxy(_self) {
            return (...args) => { _self.stateHelperService.goToItem(...args) };
        }

        function goToActivityProxy(_self) {
            return (...args) => { _self.stateHelperService.goToActivity(...args) };
        }

        function getActivityUrlProxy(_self) {
            return (activity) => _self.stateHelperService.getActivityUrl(activity);
        }

        //Returns an object with closures for each method,
        //to preserve the lexical scope of the instance
        return {
            getStateForSectionRefId: getStateForSectionRefIdProxy(_self),
            getUrlForSectionRefId: getUrlForSectionRefIdProxy(_self),
            serialize: serializeProxy(_self),
            goToItem: goToItemProxy(_self),
            goToActivity: goToActivityProxy(_self),
            getActivityUrl: getActivityUrlProxy(_self)
        }
    }

    /** Message display methods **/

    public showMsg(options: any) {
        options.title = options.title || '';
        options.url = options.url || false;
        options.notificationType = options.notificationType || 'auto';

        var settings = {
            type: options.type || 'success',
            delay: options.delay || 5000,
            allow_dismiss: true,
            url_target: '_self',
            stackup_spacing: 5
        };

        if (options.glyph) {
            options.icon = "glyphicon glyphicon-" + options.glyph;
            options.notificationApiImage = options.notificationApiImage || '/core/img/favicons/favicon.ico';
        } else {
            options.icon = (options.user) ? '/api/user/' + options.user.unixName + '/avatar' : '/core/img/logos/gforge-bg-white.png';
            settings['icon_type'] = 'image';
            settings['icon'] = options.icon;
            options.notificationApiImage = options.notificationApiImage || options.icon;
        }

        //notifyType = 'auto': will detect if page has focus. If it's focused will growl, if not will send desktop notification
        //notifyType = 'growlNotification': will force a growl
        //notifyType = 'desktopNotification: will force a desktop notification
        if ((options.notificationType == 'auto' && this._isOnFocus) || options.notificationType == 'growl') {
            ($ as any).notify(options, settings);
        } else if ((options.notificationType == 'auto' && !this._isOnFocus) || options.notificationType == 'notificationsApi') {
            webNotification.showNotification(
                options.title,
                {
                    body: this.plainTextBody(options.message),
                    icon: options.notificationApiImage,
                    autoClose: options.delay || 5000,
                    onClick: options.onClickCallback
                },
                function onShow(error, hide) {
                    if (error && options.notificationType != 'notificationsApi') {//it might mean the user blocked notifications, do a growl instead
                        ($ as any).notify(options, settings);
                    }
                }
            );
        }
    }

    /**
     * Plain-text rendition of a growl message, for the desktop Notification
     * API (whose `body` is text, not markup).
     *
     * Stripping tags is not enough on its own: callers that hand the growl
     * user-authored Markdown have to escape it first, because bootstrap-notify
     * inserts the message as HTML. Decoding afterwards is what keeps the
     * desktop notification reading "Can't" rather than "Can&#39;t".
     *
     * The textarea is detached and its content is raw text by definition, so
     * assigning already-stripped markup to it cannot run anything.
     */
    private plainTextBody(message): string {
        const stripped = this.htmlToPlainTextPipe.transform(message);
        if (!stripped) {
            return '';
        }
        const decoder = this.document.createElement('textarea');
        decoder.innerHTML = stripped;
        return decoder.value;
    }

    setFocus(id) {
        setTimeout(function () {
            var element = this.window.document.getElementById(id);
            if (element)
                element.focus();
            if (_.get(element, 'setSelectionRange', false)) {
                element.setSelectionRange(0, 0);
            }
        });
    }

    setActiveTab(scope, strTab) {
        if (strTab === undefined) {
            strTab = '';
        }
        if (strTab === '') {
            var arr_hash = this.window.location.hash.split('#');
            if (arr_hash.length == 3) {
                strTab = arr_hash[2];
            }
        }
        if (strTab !== '') {
            scope.activeTab = strTab;
        }
    }

    public showSuccessMsg(strMessage, strTitle: string = "", options: any = null) {
        options = options || {};

        options.title = strTitle || 'Success';
        options.message = strMessage;
        options.type = 'success';
        if (_.isEmpty(options.user)) {
            options.glyph = 'ok-sign';
        }

        this.showMsg(options);
    }

    showInfoMsg(strMessage, strTitle?, options?) {
        options = options || {};

        options.title = strTitle || 'Notice';
        options.message = strMessage;
        options.type = 'info';
        if (_.isEmpty(options.user)) {
            options.glyph = 'info-sign';
        }

        this.showMsg(options);
    }

    showWarningMsg(strMessage, strTitle?, options?) {
        options = options || {};

        options.title = strTitle || 'Warning';
        options.message = strMessage,
            options.type = 'warning';
        if (_.isEmpty(options.user)) {
            options.glyph = 'exclamation-sign';
        }

        this.showMsg(options);
    }

    showErrorMsg(strMessage, strTitle?, options?) {
        options = options || {};

        options.title = strTitle || 'Error';
        options.message = strMessage;
        options.type = 'danger';
        if (_.isEmpty(options.user)) {
            options.glyph = 'exclamation-sign';
        }

        this.showMsg(options);
    }

    /**
     * Receives an object as returned from API, process it, shows growl message
     * and returns jobId, 0 if no jobId found.
     * Object returned can be:
     *   - If user sent a request and it was backgrounded on API:
     *     {objId: NN}
     *   - If user sent a request and it was processed online, OR on poll
     *     replies for a background job:
     *     {33:{status:12,statusText:"Success"}, ...}
     */
    showJobMessage(objResponse: any) {
        var msgOk = '';
        var msgErr = '';
        var jobId = 0;
        _.forEach(objResponse, function (obj, key: any) {
            if (/^[0-9]+$/.test(key)) {//key is numeric id, obj is item
                if (obj.status == 12) {//12 is BackgroundJob::RESULT_SUCCESS
                    msgOk += ((msgOk) ? ', ' : '') + '#' + key;
                } else {
                    msgErr += ((msgErr) ? ', ' : '') + '#' + key;
                }
            } else if (key == 'jobId') {//key is jobId, obj is id
                jobId = obj;//obj is the id
            }
        });
        if (jobId) {//objResponse only contains a jobId
            msgOk = 'Your request is being processed, please wait.';
        } else {//objResponse contains list of success/failed items
            if (msgOk) {
                msgOk = 'Items processed: ' + msgOk;
            }
            if (msgErr) {
                msgErr = '\nItems failed: ' + msgErr;
            }
        }
        if (msgErr) {
            this.showWarningMsg(msgOk + msgErr);
        } else {
            this.showSuccessMsg(msgOk + msgErr);
        }
        return jobId;
    }

    showFormError(errorMsg) {
        this.showErrorMsg(errorMsg);
    }

    /** Utility methods for Forms **/

    getParent(fieldName: string = "", levelsUp: number = 0) {
        var el = this.document.getElementById(fieldName);
        var parentEl = el;
        for (var i = 0; i < levelsUp; i++) {
            parentEl = parentEl.parent();
        }

        return parentEl;
    }

    clear(fieldName, levelsUp) {
        var parentEl = this.getParent(fieldName, levelsUp);
        var isFirst = true;

        var children = parentEl.children();
        _.forEach(children, function (element) {
            if (isFirst) {
                isFirst = false;
            } else {
                element.remove();
            }
        });
    }

    removeChecking(fieldName) {
        var parentEl = this.getParent(fieldName, 3);
        var children = parentEl.children();
        _.forEach(children, function (element) {
            if ($(element).hasClass('checking')) {
                element.remove();
            }
        });
    }

    show(fieldName, levelsUp, strMessage) {
        var parentEl = this.getParent(fieldName, levelsUp);
        parentEl.after(strMessage);
    }

    //TODO used on registerController only, if
    //added to other controller will need to be
    //improved
    showChecking(fieldName: string, isSuccess: boolean) {
        var iconClass = 'glyphicon-refresh el-pulse ti_icons';
        var msg = 'Checking...';
        if (isSuccess) {
            iconClass = 'glyphicon-thumbs-up';
            msg = 'This username is available';
        }
        var strMessage = '<div class="checking small help-block"><i class="glyphicon ' + iconClass + '" style="margin-right:1em;"></i>' + msg + '</div>';
        this.show(fieldName, 2, strMessage);
    }

}
